import {IconButton, Tooltip} from '@mui/material'
import PlaylistAddIcon from '@mui/icons-material/PlaylistAddRounded'
import './datxIcon.scss'

const AddToListButton = ({
                             onClick,
                             tooltip,
                             isDisabled = false,
                             isSearchToolbarButton = false
                         }: {
    onClick: () => void;
    tooltip?: string;
    isDisabled?: boolean,
    isSearchToolbarButton?: boolean
}) => {
    return (
        <Tooltip title={tooltip}>
            <IconButton
                className={isSearchToolbarButton ? undefined : 'datxIcon'}
                aria-label="add-to-list"
                color="primary"
                onClick={onClick}
                data-testid="add-to-list-button"
                disabled={isDisabled}
            >
                <PlaylistAddIcon/>
            </IconButton>
        </Tooltip>
    )
}

export default AddToListButton
